export const buildStringWithDelimiter = (
  words: (string | undefined)[] = [],
  delimiter: string,
): string =>
  words
    .map((word) => (word != null && word !== '' && word) || '')
    .join(delimiter);

export const isAllStringsFalsy = (
  ...strings: (string | undefined | null)[]
): boolean => strings.every((str) => str == null || str === '');
